import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import flowizLogo from '../../assets/flowiz-logo.png';

export default function Navigation() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <nav className="sticky top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200/50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo */}
          <motion.button
            onClick={handleLogoClick}
            className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity duration-200"
          >
            <img 
              src={flowizLogo} 
              alt="Flowiz Logo" 
              className="w-8 h-8 sm:w-10 sm:h-10 object-contain"
            />
            <div className="text-left">
              <h1 className="text-lg sm:text-xl font-bold text-gray-900">Aquaflowz</h1>
              <p className="text-xs text-gray-600 hidden sm:block">Water Treatment Design Platform</p>
            </div>
          </motion.button>
        </div>
      </div>
    </nav>
  );
}
